import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import React__default from 'react';
import classNames from 'classnames';
import styles from './e95cdebb927862ad0531cb3d88d89f24037bf409402b966bca00dcd2d1b2d0fa.cfe-internal.js';

var _excluded = ["children", "className", "full", "small"];
var ButtonGroup = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _context;
  var children = _ref.children,
    className = _ref.className,
    full = _ref.full,
    small = _ref.small,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("span", _extends({
    role: "group"
  }, rest, {
    ref: ref,
    className: classNames(className, styles.buttonGroup, _defineProperty({}, styles.full, full))
  }), _mapInstanceProperty(_context = React__default.Children).call(_context, children, function (child) {
    if (! /*#__PURE__*/React__default.isValidElement(child)) {
      // eslint-disable-next-line no-console
      console.warn("Warning: \"".concat(child, "\" is invalid child of ButtonGroup!"));
      return null;
    }
    var buttonElementClasses = classNames(child.props.className, styles.buttonGroupElement, _defineProperty(_defineProperty({}, styles.full, full), styles.primary, child.props.kind === 'primary'));
    var buttonElementProps = {
      className: buttonElementClasses,
      full: full,
      small: small
    };
    return /*#__PURE__*/React__default.cloneElement(child, buttonElementProps);
  }));
});

export { ButtonGroup as default };
